/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import counterpart from 'counterpart';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BVLoader20 from 'Components/loaders/BVLoader';

import Button from 'Components/Button';
import PrimaryButton from 'Components/Button/PrimaryButton';
import HollowButton from 'Components/Button/HollowButton';
import OrgHierarchySelectorAccounts from '../OrgHierarchySelectorAccounts/OrgHierarchySelectorAccounts';
import OnboardingHierarchy from '../OnboardingHierarchy';
import * as globalFilterActions from 'Actions/globalFilterActions';
import './GlobalSelector.scss';

import { getGpnOrgName, getBlankHierarchyRow, getBlankHierarchyRowGpn,getBlankHierarchyRowHpy, getBlankHierarchyRowEvo, getBlankHierarchyRowGpe, getHpyOrgName,
getEvoOrgName, getGpeOrgName} from 'Utils/organizationAccountsUtils';

class GlobalSelectorAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {

      filters: props.currentFilter?props.currentFilter: this.props.hideApplyButtons && !props.globalFilter.filters ? this.props.canViewGpnAccountsSelector ? [getBlankHierarchyRowGpn(0)] : this.props.canViewHpyAccountsSelector ? [getBlankHierarchyRowHpy(0)] : this.props.canViewGpeAccountsSelector ? [getBlankHierarchyRowGpe(0)] : this.props.canViewEvoAccountsSelector ? [getBlankHierarchyRowEvo(0)] : [getBlankHierarchyRow(0)]  : props.globalFilter.filters,
      pendingFilters: props.currentFilter?props.currentFilter: this.props.hideApplyButtons && !props.globalFilter.filters ? this.props.canViewGpnAccountsSelector ? [getBlankHierarchyRowGpn(0)] : this.props.canViewHpyAccountsSelector ? [getBlankHierarchyRowHpy(0)] : this.props.canViewGpeAccountsSelector ? [getBlankHierarchyRowGpe(0)] : this.props.canViewEvoAccountsSelector ? [getBlankHierarchyRowEvo(0)] : [getBlankHierarchyRow(0)] : [...props.globalFilter.filters],
      pendingChanges: false,
      totalSelectedMerchants: null,
      resetCount: 0,
      setExistingFilters: false,
      merchantSelector: false,
    };

    if (!props.currentFilter) {
      const filters = this.props.canViewGpnAccountsSelector ? [getBlankHierarchyRowGpn(0)] : this.props.canViewHpyAccountsSelector ? [getBlankHierarchyRowHpy(0)] : this.props.canViewGpeAccountsSelector ? [getBlankHierarchyRowGpe(0)] : this.props.canViewEvoAccountsSelector ? [getBlankHierarchyRowEvo(0)] : [getBlankHierarchyRow(0)];
      const pendingFilters = [...filters];
      let merchantSelector = false;
      
      if (props.globalFilter.orgIds.length > 0 && props.globalFilter.filters.length < 1 && props.globalFilter.scheduleOrgIds.length < 1) {
        merchantSelector = true;
      }
      
      this.setState({
        filters: filters,
        pendingFilters: pendingFilters,
        merchantSelector: merchantSelector
      });
    }
    if (props.existingScheduleFilters && props.existingScheduleFilters.length > 0) {    
      const filters = props.existingScheduleFilters;
      const pendingFilters = [...filters];

      this.setState({
        filters: props.existingScheduleFilters,
        pendingFilters: pendingFilters
      });
    }
    if (this.props.editCurrentgSchedule) {    
      const filters = this.props.globalFilter.scheduleFilters;
      const pendingFilters = [...filters];

      this.setState({
        filters: this.props.globalFilter.scheduleFilters,
        pendingFilters: pendingFilters
      });
    }

    this.attachBindings();
    if (this.props.clearScheuldeFilters) { this.updateSelector(); }
  }

  // when OrgHierarchySelector fires event indicating the filters have changed
  onFiltersChanged(newFilters, merchantCount, merchantList) {
    this.setState({
      pendingFilters: [...newFilters],
      pendingChanges: true,
      totalSelectedMerchants: merchantCount,
    });
    this.props.updateMerchantList(newFilters.map(e => e.selectedOrgIds),newFilters.map(e => e.manualSearchMid), newFilters);
  
    // In case if this function gets called from global selector
    // accordion which would be diaplyed on schedule creation page
    // then need to update state on change of hierarchy values
    if (this.props.hideApplyButtons) {
      this.updateSelector(merchantList);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.existingScheduleFilters != this.props.existingScheduleFilters) {
      const existingScheduleFilters = nextProps.existingScheduleFilters;
      this.setState({ filters: [...existingScheduleFilters],
        pendingFilters: [...nextProps.existingScheduleFilters],
        setExistingFilters: true,
        merchantSelector: false });
    }
    if (this.props.merchantHierarchyRest != nextProps.merchantHierarchyRest && nextProps.merchantHierarchyRest) {
      this.clearSelector();
    }
   else if(this.props.currentFilter && nextProps.currentFilter && this.props.currentFilter.length>0 && nextProps.currentFilter.length>0 && this.props.currentFilter!=nextProps.currentFilter){
      this.setState({
        pendingFilters: [...nextProps.currentFilter],
        pendingChanges: true,
        totalSelectedMerchants: nextProps.merchantCount,
      });
    }
  }
  
  componentDidUpdate(prevProps) {
    if (this.state.setExistingFilters) {
      this.updateSelector();
      this.setState({ setExistingFilters: false });
    }
  }
  componentDidMount() {
    if (this.state.merchantSelector) {
     
      this.props.getOrgdetailsForMerchantSelector(this.props.globalFilter.orgIds);
    }
    if(this.props.currentFilter  && this.props.currentFilter.length>0){
    this.setState({
      pendingFilters: [...this.props.currentFilter],
      pendingChanges: true,
      totalSelectedMerchants: this.props.merchantCount,
    });
  }
  }
  // handles returning to the previous page
  goBack() {
    const currentLocation = this.props.history.location.currenctLocation; // misspelling coming from backend
    if (currentLocation) {
      this.props.history.push(currentLocation);
    } else if (this.props.location.state && this.props.location.state.savePreviousFilters) {
      this.props.history.push(this.props.location.state.currentLocation);
    } else {
      this.props.history.goBack();
    }
  }

  getOrgIdsForSelectedHierarchy(selectedHierarchyCode) {
    const orgList = this.props.organization.cachedLoginUserOrgs;
    // check to see if this org is in the top level, and if so return it's id
    const selectedOrgId = orgList.TOP_LEVEL.filter(x => x.hierarchyCode === selectedHierarchyCode && x.orgId && x.orgId > 0).map(x => x.orgId);
    if (selectedOrgId.length > 0) {
      return selectedOrgId;
    }
    // otherwise check children recursively until orgs with IDs found (representing orgs they have direct access to)
    const selectedOrg = orgList[selectedHierarchyCode];
    if (!selectedOrg) return [];
    const childIds = selectedOrg.map(p => (p.orgId) ? p.orgId : null).filter(x => x);
    if (childIds.length > 0) {
      return childIds;
    } else {
      let nestedIds = [];
      selectedOrg.forEach(o => {
        nestedIds = nestedIds.concat(this.getOrgIdsForSelectedHierarchy(o.hierarchyCode));
      });
      return nestedIds;
    }
  }

  // saves the current filters to redux
  updateSelector(merchantList = []) {
    let orgIds = [].concat(...this.state.pendingFilters.map((f) => f.selectedOrgIds));

    // for any rows where a top level organization was selected that the user does not have direct access to (for example, they have merchant level access and set Region to 'All')
    const rowsWithoutOrgIds = this.state.pendingFilters.filter(f => f.selectedOrgIds.length === 0);
    rowsWithoutOrgIds.forEach(o => {
      // fetch the most immediate descendant organization(s) under the selected one for which the user has direct access
      const selectedColumn = [...o.row].reverse().find(r => r.selectedItems.length > 0);
      if (selectedColumn) {
        const ids = this.getOrgIdsForSelectedHierarchy(selectedColumn.selectedItems[0].hierarchyCode);
        orgIds = orgIds.concat(ids);
      }
    });
    const merchantCount = this.state.totalSelectedMerchants;

    if (!this.props.hideApplyButtons) {
      const orgTypes = [].concat(...this.state.pendingFilters.map((f) => f.selectedOrgTypes)).sort((a, b) => b - a);
      const orgName = orgTypes.length > 0 ? (this.props.canViewHpyAccountsSelector ? getHpyOrgName(orgTypes[0]) : this.props.canViewEvoAccountsSelector ? getEvoOrgName(orgTypes[0]) : this.props.canViewGpeAccountsSelector ? getGpeOrgName(orgTypes[0]).toUpperCase() : getGpnOrgName(orgTypes[0]).toUpperCase()) : '';
      this.props.actions.updateGlobalFilter(this.state.pendingFilters, orgIds, merchantCount.toString(), orgName);
      this.goBack();
    } else {
      // In case if this function gets called from global selector
      // accordion which would be diaplyed on schedule creation page
      // then no need to call goBack()
      this.props.actions.updateScheduleGlobalFilter(this.state.pendingFilters, orgIds, merchantCount || 0, merchantList);
    }
  }

  // removes all current filters from UI (change is not committed untilSelector update called)
  clearSelector() {
    this.props.updateMerchantList(this.props.canViewGpnAccountsSelector ? getBlankHierarchyRowGpn(0) : this.props.canViewHpyAccountsSelector ? getBlankHierarchyRowHpy(0) : this.props.canViewGpeAccountsSelector ? getBlankHierarchyRowGpe(0) : this.props.canViewEvoAccountsSelector ? getBlankHierarchyRowEvo(0) : getBlankHierarchyRow(0));
    this.setState({ pendingFilters: this.props.canViewGpnAccountsSelector ? [getBlankHierarchyRowGpn(0)] : this.props.canViewHpyAccountsSelector ? [getBlankHierarchyRowHpy(0)] : this.props.canViewGpeAccountsSelector ? [getBlankHierarchyRowGpe(0)] : this.props.canViewEvoAccountsSelector ? [getBlankHierarchyRowEvo(0)] : [getBlankHierarchyRow(0)], totalSelectedMerchants: null, resetCount: this.state.resetCount + 1, pendingChanges: true });
  }

  // resets the filters to last saved filter state from redux
  resetSelector() {
    this.setState({ pendingFilters: [...this.state.filters], totalSelectedMerchants: null, resetCount: this.state.resetCount + 1, pendingChanges: true });
  }

  // cancels any unsaved pending changes and closes the global filter screen and returns to home page
  cancelCloseSelector() {
    this.goBack();
  }

  attachBindings() {
    this.clearSelector = this.clearSelector.bind(this);
    this.cancelCloseSelector = this.cancelCloseSelector.bind(this);
    this.resetSelector = this.resetSelector.bind(this);
    this.updateSelector = this.updateSelector.bind(this);
    this.onFiltersChanged = this.onFiltersChanged.bind(this);
    this.getOrgIdsForSelectedHierarchy = this.getOrgIdsForSelectedHierarchy.bind(this);
  }

  render() {
    const isSupportProvider = false;
    const requestedByMerchantCount = this.props.supportData.requestedByMerchantCount;
    const merchantSelectedText = this.state.totalSelectedMerchants === 1 ? counterpart('globalTranslate.globalSelector.merchants.one') : counterpart('globalTranslate.globalSelector.merchants.other');
    return (
      <article className={!this.props.hideApplyButtons ? 'top-bottom-content global-selector-container' : 'top-bottom-content global-selector-container data-access-selector'}>
        {this.props.isFetching && false&&
          <div className="loader-cover">
            <BVLoader20 width={'50px'} fill={'#0a61ad'} bgColor={'rgba(0, 0, 0, .15)'} />
          </div>
        }
        <div className="top-content">
          { !this.props.isSchedulerWizard && this.props.enableAddMoreButton &&  <header className="top-content main-content--header">
            <h1>{isSupportProvider ? counterpart('globalTranslate.globalSelector.supportTitle') : counterpart('globalTranslate.globalSelector.titleMerchant')}</h1>
            {!isSupportProvider &&
              <div className="button-group-horizontal">
                <Button
                  type="button"
                  action={this.clearSelector}
                  extraClass="button-group-horizontal-border"
                >
                  {counterpart('globalTranslate.globalSelector.clearAll')}
                </Button>
              </div>
            }
          </header> }
          <section className={!this.props.hideApplyButtons ? 'padded' : ''}>
            {this.props.enableAddMoreButton && <div className="subHierarchyTitle">
              {!isSupportProvider && this.props.enableAddMoreButton ? counterpart('globalTranslate.globalSelector.subTitle') : counterpart('globalTranslate.globalSelector.supportSubTitle')}
            </div>}
            {!this.state.merchantSelector  &&
            <OrgHierarchySelectorAccounts
              isGlobalSelector
              enableAddMoreButton={this.props.enableAddMoreButton}
              hierarchyRowChangedCallback={this.onFiltersChanged}
              hierarchyRows={this.state.pendingFilters}
              resetCount={this.state.resetCount}
              prepopulatedMerchantId={this.props.prepopulatedMerchantId}
              canViewGpnAccountsSelector={this.props.canViewGpnAccountsSelector}
              canViewEvoAccountsSelector={this.props.canViewEvoAccountsSelector}
              canViewHpyAccountsSelector={this.props.canViewHpyAccountsSelector}
              canViewGpeAccountsSelector={this.props.canViewGpeAccountsSelector}
              canViewHierarchySelector={this.props.canViewHierarchySelector}
            />}
          </section>
        </div>
        {!this.props.hideApplyButtons && <footer className="bottom-content">
          <div className="left-right-content padded-tall">
            {isSupportProvider &&
            <div className="left-content">
              {requestedByMerchantCount > 0 ? requestedByMerchantCount : counterpart('globalTranslate.globalSelectorFlag.all') } {counterpart('globalSelector.merchants', { count: JSON.parse(this.props.supportData.requestedByMerchantCount) })}
            </div>
            }
            {!isSupportProvider &&
              <div className="left-content">
                {/* todo: remove the isExternalUser condition once API to retrieve merchant count based on selections is available */}
                {(this.state.totalSelectedMerchants > 0 ? `${this.state.totalSelectedMerchants} ${merchantSelectedText}` : counterpart('globalSelector.allMerchants'))}
              </div>
            }
            { isSupportProvider &&
              <div className="button-group-horizontal">
                <PrimaryButton type="button" action={this.closeSelector}>{counterpart('globalTranslate.globalSelector.close')}</PrimaryButton>
              </div>
            }
            {!isSupportProvider &&
              <div>
                <div className="button-group-horizontal">
                  <HollowButton type="button" action={this.cancelCloseSelector} extraClass="cancel">{counterpart('globalTranslate.globalSelector.cancel')}</HollowButton>
                  <HollowButton type="button" action={this.resetSelector} extraClass="reset">{counterpart('globalTranslate.globalSelector.reset')}</HollowButton>
                  <PrimaryButton type="button" action={this.updateSelector} disabled={!this.state.pendingChanges}>{counterpart('globalTranslate.globalSelector.select')}</PrimaryButton>
                  {this.state.pendingChanges > 0 &&
                    <OnboardingHierarchy topicKey="Select" extraClass="select" />
                  }
                </div>
              </div>
            }
          </div>
        </footer>}
      </article>
    );
  }
}

GlobalSelectorAccounts.propTypes = {
  actions: PropTypes.object.isRequired,
  supportData: PropTypes.object,
  globalFilter: PropTypes.object,
  history: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  hideApplyButtons: PropTypes.bool,
  clearScheuldeFilters: PropTypes.bool,
  isSchedulerWizard: PropTypes.bool,
  organization: PropTypes.array.isRequired,
};


GlobalSelectorAccounts.defaultProps = {
  supportData: {},
  globalFilter: {},
  hideApplyButtons: false,
  clearScheuldeFilters: false,
};


const mapStateToProps = (state) => ({
  isFetching: state.organization && state.organization.countIsFetching,
  supportData: state.support && state.support.currentSupportRequest,
  globalFilter: state.globalFilter,
  organization: state.organization,
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(globalFilterActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GlobalSelectorAccounts));
